export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_12.d034dd24.jpg";